import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'

import messages from './messages'

import HeaderBanner from 'components/ui/banners/HeaderBanner/HeaderBanner'


export default class ShippingDelayBanner extends PureComponent {

  static propTypes = {
    onClose: PropTypes.func.isRequired,
  }

  openBlogPage = () => {
    actions.models.router.push('https://www.scentbird.com/blog/a-letter-from-our-ceo', true)
  }

  render() {
    const { onClose } = this.props

    return (
      <HeaderBanner
        onClose={onClose}
        textMessage={messages.text}
        btnMessage={messages.button}
        onClick={this.openBlogPage}
      />
    )
  }
}
